import React, { useState, useEffect } from 'react';
// Components:
import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import { CotplayHubSelectors } from 'app/containers/CotplayHubContainer/CotplayHubSelectors/CotplayHubSelectors';
import { CotplayHubVideoContainer } from '../../containers/CotplayHubContainer/CotplayHubVideoContainer/CotplayHubVideoContainer';

// Material Design:
import { Tabs } from 'antd';
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';

// Styles:
import { useStyles, styles } from './CotplayHubScreenStyles';

export default function CotplayHubScreen(props) {

    const classes = useStyles();
    const [isMostViewed, setisMostViewed] = useState(false);
    const { TabPane } = Tabs;
    const [activeKey, setTabBar] = useState('1');
    const tabs = { '1': 'Cotplay Hub' }

    return (
        <div className={classes.root}>

            <NavMenu
                SelectedIndex={props.history.location.pathname}
                header='CotPlay HUB'
                isCommunicationStatus={false}
            />

            <div className={`${classes.content}`}>

                    <div
                        elevation={0}
                        style={styles.titleBox}
                    >
                <div className={classes.BreadcrumbsBox}>
                        <Breadcrumbs
                            style={{ marginTop: '15px', marginBottom: '10px' }}
                            aria-label="Breadcrumb"
                        >
                            <TextEvents
                                text={'CotPlay HUB'}
                                color="cotemar"
                                size='subtitle'
                                weight="bold"
                            />
                        </Breadcrumbs>
                        <div className={classes.HubOptions}>
                            <CotplayHubSelectors
                                isMostViewed={isMostViewed}
                                setisMostViewed={setisMostViewed}
                            />
                        </div>
                    </div>
                </div>

                <CotplayHubVideoContainer isMostViewed={isMostViewed} />

            </div>

        </div>
    )
}